import "../scss/index.scss";
jQuery(function ($) {

    // Do stuff here
    var deviceModeOld = false;
    var isScrolled = false;
    var isScrolledClass = false;
    var scroll = $(window).scrollTop();
    setScrolledClass(scroll);

    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        setScrolledClass(scroll);
    });

    function setScrolledClass(scroll) {
        if (scroll > 30) {
            isScrolled = true;
        } else {
            isScrolled = false;
        }

        if (isScrolled === true && isScrolledClass === false) {
            $('body').addClass('scrolled');
            //$('body.home #nav-main').removeClass('navbar-dark').addClass('navbar-light');
            isScrolledClass = true;
        } else if (isScrolled === false && isScrolledClass === true) {
            $('body').removeClass('scrolled');
            //$('body.home #nav-main').removeClass('navbar-light').addClass('navbar-dark');
            isScrolledClass = false;
        }
    }

    //toogle la description produit en mode mobile
    function toggleAccordion(deviceMode) {
        if (deviceMode == 'mobile') {
            $('.product__single__description .e-n-accordion-item').removeAttr('open');
        } else {
            $('.product__single__description .e-n-accordion-item').attr('open', true);
        }
    }

    $('body').on( 'checkout_error', function () {
        $( 'ul.woocommerce-error li').each(function(i) {
            if($(this).attr('data-id') === "professional" ) {
                $( '#professional_field' ).addClass( 'woocommerce-invalid' );
            }
        });
    });

    if($('body').hasClass('woocommerce-checkout')) {
        $( 'body' ).on( 'blur change', '#professional_field input[name="professional"]', function(){

            const wrapper = $('#professional_field' );
            // you do not have to removeClass() because Woo do it in checkout.js

            if ($('#professional_field input[name="professional"]').is(":checked")) {
                wrapper.addClass( 'woocommerce-validated' ).removeClass('woocommerce-invalid'); // success
            } else {
                wrapper.addClass( 'woocommerce-invalid' ).removeClass('woocommerce-validated'); // error
            }
        });
    }

// géré directement avec un btn custom + lien direct checkout
// 
//    if (typeof jsvars !== "undefined" && typeof jsvars.wcCheckoutUrl !== "undefined") {
//        $('.elementor-menu-cart__toggle_button').on('click', function (event) {
//            event.preventDefault();
//            event.stopPropagation();
//            window.location.href = jsvars.wcCheckoutUrl;
//        });
//    }

    //btn cart custom, trigger real btn
    $('.btn-add-to-cart').on('click', function (event) {
        event.preventDefault();
        $('.single_add_to_cart_button').click();
    });
    
    
    let homeRealisationSlider;
    
    function homeRealisationSlidify(deviceMode) {
        if ($('.home .realisation__slider').length) {
            
            if (deviceMode == 'mobile' || deviceMode == 'tablet') {

                if (homeRealisationSlider == undefined) {

                    $('.realisation__slider').removeClass('e-grid').addClass('e-flex');
                    $('.realisation__slider').addClass('swiper');
                    $('.realisation__slider > div').addClass('swiper-wrapper').removeClass('e-con-inner');
                    if ($('.realisation__slider .realisation__teaser').parent().not('.swiper-slide')) {
                        $('.realisation__slider .realisation__teaser').wrap('<div class="swiper-slide"></div>');
                    }
                    //on clone le dernier slide qu'on rend invisible juste pour le débordement et pour pouvoir voir entièrement le vrai dernier slide
                    if (!$('.realisation__slider .swiper-slide-dummy').length) {
                        $('.realisation__slider .swiper-slide:last-child').clone().addClass('swiper-slide-dummy').appendTo('.realisation__slider .swiper-wrapper');
                    }

                    homeRealisationSlider = new Swiper('.realisation__slider', {
                        loop: false,
                        //autoHeight: true,
                        pagination:false,
                        navigation:false,
                        autoplay: {
                            delay: 5000,
                        },
                        // Default parameters
                        slidesPerView: 2,
                        spaceBetween: 10,
                        // Responsive breakpoints
                        breakpoints: {
                          // when window width is >= 767px
                          767: {
                            slidesPerView: 3
                          },
                        }
                    });
                }
            } else {

                if (homeRealisationSlider !== undefined) {

                    $('.realisation__slider').removeClass('e-flex').addClass('e-grid');
                    $('.realisation__slider').removeClass('swiper');
                    $('.realisation__slider > div').removeClass('swiper-wrapper').addClass('e-con-inner');
                    $('.realisation__slider .swiper-slide-dummy').remove();
                    if ($('.realisation__slider .realisation__teaser').parent().hasClass('swiper-slide')) {
                        $('.realisation__slider .realisation__teaser').unwrap();
                    }

                    homeRealisationSlider.destroy(true, true);
                    homeRealisationSlider = undefined;
                }
            }
        }
    }

    
    let homeProductSlider;
    
    function homeProductSlidify(deviceMode) {
        if ($('.home #product__slider').length) {

            if (deviceMode == 'mobile' || deviceMode == 'tablet') {

                if (homeProductSlider == undefined) {

                    $('#product__slider').removeClass('e-grid').addClass('e-flex');
                    $('#product__slider').addClass('swiper');
                    $('#product__slider > div').addClass('swiper-wrapper').removeClass('e-con-inner');
                    if ($('#product__slider .product__teaser').parent().not('.swiper-slide')) {
                        $('#product__slider .product__teaser').wrap('<div class="swiper-slide"></div>');
                    }
                    
                    //on clone le dernier slide qu'on rend invisible juste pour le débordement et pour pouvoir voir entièrement le vrai dernier slide
                    if (!$('#product__slider .swiper-slide-dummy').length) {
                        $('#product__slider .swiper-slide:last-child').clone().addClass('swiper-slide-dummy').appendTo('#product__slider .swiper-wrapper');
                    }
                    
                    homeProductSlider = new Swiper('#product__slider', {
                        loop: false,
                        //autoHeight: true,
                        pagination:false,
                        navigation:false,
                        autoplay: {
                            delay: 5000,
                        },
                        // Default parameters
                        slidesPerView: 2,
                        spaceBetween: 10,
                        // Responsive breakpoints
                        breakpoints: {
                          // when window width is >= 767px
                          767: {
                            slidesPerView: 3
                          },
                        }
                    });
                }
            } else {

                if (homeProductSlider !== undefined) {

                    $('#product__slider').removeClass('e-flex').addClass('e-grid');
                    $('#product__slider').removeClass('swiper');
                    $('#product__slider > div').removeClass('swiper-wrapper').addClass('e-con-inner');
                    $('#product__slider .swiper-slide-dummy').remove();
                    if ($('#product__slider .product__teaser').parent().hasClass('swiper-slide')) {
                        $('#product__slider .product__teaser').unwrap();
                    }

                    homeProductSlider.destroy(true, true);
                    homeProductSlider = undefined;
                }
            }
        }
    }
    
    $('.share-btn').on('click',function() {
        var sharelinks = $(this).parent().find('.share-links').toggle();
    });
    
    $('.share-btn').on( "mouseenter",
        function() {
            $(this).parent().find('.share-links').show();
        });
    $('.share-wrapper').on( "mouseleave",
        function() {
            $(this).find('.share-links').hide();
        });

    $('.elementor-nav-menu--main > ul').on('show.smapi', function(e, menu) { 
        var target = $(menu).attr('id');
        $('#'+target).height(0);
        $('#'+target).animate({ height: $('#'+target).get(0).scrollHeight }, 400, function() { $(this).height('auto'); });
    });
    
    $('.elementor-nav-menu--main > ul').on('hide.smapi', function(e, menu) {
        var target = $(menu).attr('id');
        $('#'+target).height(0);
    });


    var body = document.body;

    var observer = new MutationObserver(function (mutations) {
        for (var mutation of mutations) {
            if (mutation.type === "attributes" && mutation.attributeName === 'data-elementor-device-mode') {

                var deviceMode = mutation.target.getAttribute('data-elementor-device-mode');
                
                if (deviceMode !== deviceModeOld) {
                    toggleAccordion(deviceMode);
                    homeProductSlidify(deviceMode);
                    homeRealisationSlidify(deviceMode);
                    deviceModeOld = deviceMode;
                }
            }
        }
    });
    
    /**
     * window resize basé sur le class device (breakpoint) elementor
     */

        observer.observe(body, {
            attributes: true,
            attributeOldValue: true,
            childList: false,
            subtree: false,
            attributeFilter: ['data-elementor-device-mode']
        });
        
    //prevent multiple submission
    $('.wpcf7-form').on('submit', function() {
        
        $(this).find('.wpcf7-submit').attr('disabled', true);
        $(this).find('.wpcf7-submit').val('Envoi en cours');
    });
    
    $('.wpcf7').on('wpcf7submit', function (e) {
        $(this).find('.wpcf7-submit').removeAttr('disabled');
        $(this).find('.wpcf7-submit').val('Envoyer');
    });


}); // jQuery End



document.addEventListener( 'wpcf7submit', function( event ) {
  var inputs = event.detail.inputs;
 
  for ( var i = 0; i < inputs.length; i++ ) {
    if ( 'your-name' == inputs[i].name ) {
      alert( inputs[i].value );
      break;
    }
  }
}, false );